/*
 * @Author: shiguang
 * @Date: 2024-04-15 14:37:44
 * @LastEditors: shiguang
 * @LastEditTime: 2024-06-17 01:20:08
 * @Description: 
 */
const ScrollTopIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="&#229;&#142;&#187;&#233;&#161;&#182;&#233;&#131;&#168;_to-top 1">
                <path id="Vector" d="M12.0039 7.05029V21" stroke="#1C2026" strokeWidth="2" stroke-linecap="round" strokeLinejoin="round" />
                <path id="Vector_2" d="M6 13L12 7L18 13" stroke="#1C2026" strokeWidth="2" stroke-linecap="round" strokeLinejoin="round" />
                <path id="Vector_3" d="M6 3H18" stroke="#1C2026" strokeWidth="2" stroke-linecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    )
}

export default ScrollTopIcon;